import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <React.Fragment>
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M11.0651 13.0863C10.0726 14.5409 7.92742 14.5409 6.93492 13.0863L1.35537 4.90906C0.223089 3.2496 1.41151 1 3.42046 1L14.5795 1C16.5885 1 17.7769 3.2496 16.6446 4.90906L11.0651 13.0863Z"
      stroke="currentColor"
      fill="none"
    />
  </React.Fragment>,
  "ArrowOpenedIcon"
);
